import styled from 'styled-components'

const Wrapper = styled.div`
  position: fixed;
  max-width: 320px;
  min-height: 100px;
  background: ${p => p.theme.colors.light};
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  color: ${p => p.theme.colors.dark};
  padding: 20px 10px;
  user-select: none;
  left: 15px;
  right: 15px;
  margin: 0 auto 0 auto;
  border-radius: 10px;
`

const Title = styled.span`
  font-family: ${p => p.theme.fonts.tertiary};
  font-size: 1.1rem;
  opacity: 0.8;
  font-weight: bold;
`

const Content = styled.p`
  font-family: ${p => p.theme.fonts.secondary};
  opacity: 0.6;
  font-size: 0.9rem;
  line-height: 1.2;
  text-align: center;
  margin-top: 15px;
`

const ButtonGroup = styled.div`
  width: 100%;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    border: 1px solid #eee;
    border-radius: 4px;
    color: ${p => p.theme.colors.light};
    display: inline-block;
    font-weight: 600;
    line-height: 1.7;
    padding: 6px 17px;
    text-decoration: none;
    margin: 0px 5px;
    outline: none;
    opacity: 0.7;

    :first-child {
      background: ${p => p.theme.colors.success};
    }

    :last-child {
      background: ${p => p.theme.colors.danger};
    }

    :hover,
    :focus {
      opacity: 1;
    }
  }
`

export { Wrapper, Title, Content, ButtonGroup }
